import { PhoneOutlined } from '@mui/icons-material';
import { Link, Typography, TypographyProps } from '@mui/material';
import { ElementType } from 'react';
import { PatternFormat } from 'react-number-format';


type PhoneTypographyProps<C extends ElementType> = TypographyProps<C, { component?: C }> & {
    children: string;
    showIcon?: boolean;
    inTable?: boolean;
};

export function PhoneTypography<C extends ElementType>({
    children, showIcon, inTable, ...typographyProps
}: PhoneTypographyProps<C>) {
    return (
        <Typography {...typographyProps}>
            {showIcon && (
                <PhoneOutlined
                    color="primary"
                    fontSize="small"
                />
            )}

            <Link href={`tel:${children}`}>
                <PatternFormat
                    format="(###) ###-####"
                    mask="_"
                    displayType="text"
                    type="tel"
                    value={children}
                />
            </Link>
        </Typography>
    );
}
